// Works around a Windows + Chrome GPU-compositing quirk where, after a
// browser window is resized or restored from maximized, the page keeps
// rendering at its previous (larger) composited scale — showing the site
// letterboxed with blank margins on both sides — until something forces a
// fresh layout/paint pass at the new window size. This isn't caused by the
// theme's own CSS (max-width rules were verified correct at every real
// viewport width); it's the browser failing to recompose the page after the
// resize. Nudging the zoom property by a fraction and back forces Chrome to
// recompute the composited layer at the current, correct size.
let viewportResizeNudgeTimer;

function nudgeViewportRepaint() {
  if (!document.body.style) return;
  document.body.style.zoom = '99.99%';
  requestAnimationFrame(() => {
    document.body.style.zoom = '100%';
  });
}

window.addEventListener('resize', () => {
  clearTimeout(viewportResizeNudgeTimer);
  viewportResizeNudgeTimer = setTimeout(nudgeViewportRepaint, 150);
});
